module.exports = __webpack_public_path__ + "img/simplepay_bankcard_logos_left.4d1baf8.png";